import Dexie from 'dexie';

export const offlineDb = new Dexie('mad_offline');

offlineDb.version(1).stores({
  // key: string (full request key), value: any json, updatedAt: number
  apiCache: '&key, updatedAt',

  // pending ops to replay when online
  // id: auto, method,url,body,headers,createdAt,retryCount,lastError
  pendingOps: '++id, createdAt, method, url',
});

export async function setCachedJson(key, value) {
  await offlineDb.apiCache.put({ key, value, updatedAt: Date.now() });
}

export async function getCachedJson(key) {
  const row = await offlineDb.apiCache.get(key);
  return row ? row.value : null;
}

export async function enqueueOp(op) {
  const row = {
    method: op.method,
    url: op.url,
    headers: op.headers || {},
    body: op.body ?? null,
    createdAt: Date.now(),
    retryCount: 0,
    lastError: null,
  };
  return await offlineDb.pendingOps.add(row);
}

export async function listPendingOps(limit = 50) {
  return await offlineDb.pendingOps.orderBy('createdAt').limit(limit).toArray();
}

export async function deletePendingOp(id) {
  await offlineDb.pendingOps.delete(id);
}

export async function markPendingOpFailed(id, errMessage) {
  await offlineDb.pendingOps.update(id, {
    retryCount: Dexie.increment(1),
    lastError: String(errMessage || 'unknown error'),
  });
}

